import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

const getRoot = prop([REDUCER_NAME]);

export const getIsPolicyFieldsEditable = createSelector(getRoot, propOr(true, 'policyFieldsEditable'));
export const getIsPartnerFieldsEditable = createSelector(getRoot, propOr(true, 'partnerFieldsEditable'));
export const getDocumentIds = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'documentIds'));
export const getTaskIsBeingCreated = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'taskIsBeingCreated'));
export const getPolicyCompanyId = createSelector(getRoot, propOr(null, 'policyCompanyId'));
export const getSelectedClient = createSelector(getRoot, propOr(null, 'selectedClient'));
export const getSelectedPolicy = createSelector(getRoot, propOr(null, 'selectedPolicy'));
